import { render } from "./Contactus.vue?vue&type=template&id=5ef83f9a&scoped=true"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"

import "./Contactus.vue?vue&type=style&index=0&id=5ef83f9a&scoped=true&lang=css"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef83f9a"]])

export default __exports__